export default {
  documents: (state) => state.documents,
  rootDocument: (state) => state.documents[0],
};
